import axios from 'axios'
import Pristine from './pristine'

const forms = document.querySelectorAll('.form-lead')

forms.forEach((form) => {
  // Create the pristine instance
  let pristine = new Pristine(form)
  const formContent = form.querySelector('.form-content')
  const spinner = form.querySelector('.spinner')
  const messageFail = form.querySelector('.message-fail')
  const messageSuccess = form.querySelector('.message-success')
  let buttonSubmit = form.querySelector('button[type="submit"]')
  const inputDate = form.querySelector('.reserve-date')
  let stepContainerState = false
  let observers = []

  // Form submission
  form.addEventListener('submit', function (e) {
    e.preventDefault()
    observers.forEach((observer) => {
      observer.disconnect()
    })

    let formData = new FormData(form)

    // check if the form is valid
    let valid = pristine.validate() // returns true or false

    let options = {
      headers: {
        'Content-Type': 'application/json',
      },
    }

    if (valid) {
      const handleSubmit = async () => {
        buttonSubmit.disabled = true
        buttonSubmit.classList.toggle('sending')
        try {
          const response = await axios.post(url, formData, options)
          if (response.status == 200) {
            handleResponse(messageSuccess, form)
            form.reset()
          } else {
          }
        } catch (error) {
          handleResponse(messageFail, form)
          console.log(error)
        }
      }
      const url = script_vars.template_root + '/send-email.php'

      handleSubmit()
    }
  })

  function handleResponse(message = false, form, responseData = false) {
    form.scrollIntoView()
    formContent.classList.toggle('hidden')
    if (
      form.closest('.form-page-box') &&
      message === form.querySelector('.message-success')
    ) {
      form.closest('.form-page-box').classList.add('hidden')
      document
        .querySelector('.form-page-box-success')
        .classList.remove('hidden')
    }
    if (message) message.classList.toggle('hidden')
    buttonSubmit.classList.toggle('sending')
    buttonSubmit.removeAttribute('disabled')
  }
})
